import { render } from "./Description.vue?vue&type=template&id=43e28737&scoped=true&ts=true"
import script from "./Description.vue?vue&type=script&lang=ts"
export * from "./Description.vue?vue&type=script&lang=ts"

import "./Description.vue?vue&type=style&index=0&id=43e28737&scoped=true&lang=less"
import "./Description.vue?vue&type=style&index=1&id=43e28737&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e28737"]])

export default __exports__